import useLogger from '@/composables/useLogger'
const logger = useLogger('copyTextMixin')

const CopyTextMixin = {
  methods: {
    copy (s) {
      navigator.clipboard.writeText(s)
        .then(() => {
          this.$flash({
            showClose: true,
            message: `Copied: ${s}`,
            type: 'mini',
            duration: 1000
          })
        })
        .catch(error => {
          logger.error('error copying to clipboard', error.message)
          this.$flash({
            showClose: true,
            message: `Unable to copy: ${s}`,
            type: 'mini',
            duration: 3000
          })
        })
    }
  }
}

export default CopyTextMixin
